import type { FC } from "react";
import { BannerPageEnum } from "types/cms";

import { FetchError, PageLayout } from "src/components";
import { useEarningsListQuery } from "src/serverApi";
import { useTranslation } from "src/translations";
import { EarningsExportButton, EarningsTable } from "./components";

export const EarningsPage: FC = () => {
    const { t } = useTranslation();

    const { data: earnings, isError, error, isLoading } = useEarningsListQuery();

    return (
        <PageLayout
            loading={isLoading}
            banner={BannerPageEnum.Earnings}
            rightCornerComponent={earnings?.data && earnings.data.length > 0 && <EarningsExportButton earnings={earnings.data} />}
            title={t("earnings.title")}
        >
            {isError ? <FetchError error={error} fallbackMessage={t("common.error")} /> : <EarningsTable earnings={earnings} />}
        </PageLayout>
    );
};
